import type { ReactNode } from 'react';
import type { CustomPayRunResponse } from '../types';
import { formatUsDate, formatUsPeriod, frequencyLabel, usePayScheduleInfo } from './runContext';

/** Pay Schedule Period / Pay Day / Pay Period read-out shown above the tables on Review, Pending and Approved Payroll, with the run's memo when it has one. */
export function RunSummary({ run, children }: { run: CustomPayRunResponse; children?: ReactNode }) {
  const { schedule } = usePayScheduleInfo(run);
  return (
    <>
      <div className="cpr-summary">
        <dl>
          <dt>Pay Schedule Period</dt>
          <dd>{frequencyLabel(schedule)}</dd>
        </dl>
        <dl>
          <dt>Pay Day</dt>
          <dd>{formatUsDate(run.checkDate)}</dd>
        </dl>
        <dl>
          <dt>Pay Period</dt>
          <dd>{formatUsPeriod(run)}</dd>
        </dl>
        {children}
      </div>
      {/* EPN-242: the preparer's memo, read-only here (it is edited in Custom Payroll before the run is sent), so the approver reads it on Pending and Approved. */}
      {run.description && (
        <dl className="cpr-memo-view" data-testid="run-memo">
          <dt>Memo</dt>
          <dd>{run.description}</dd>
        </dl>
      )}
    </>
  );
}
